module.exports = __webpack_public_path__ + "static/media/lidingshan3.1b904de5.webp";